/**
 * Third-party brand hues, as named Tailwind classes.
 *
 * A brand mark's colour is not a theme decision — LinkedIn blue is LinkedIn blue
 * in light mode, in dark mode and under every tenant theme, and a "LinkedIn"
 * affordance tinted `text-primary` stops being recognisable as one. So these are
 * a sanctioned exception to `local-rules/no-hardcoded-color`, on exactly the same
 * footing as `WHATSAPP_BRAND_TEXT_CLASS` in `WhatsAppIcon.tsx`, which has carried
 * that reasoning in a comment since before the rule existed.
 *
 * The point of naming them is that the exception is granted ONCE, here, instead
 * of at each of the five call sites that used to spell `text-[#0A66C2]` inline —
 * where nothing distinguished a deliberate brand hue from a careless one.
 *
 * Only add a constant here for a hue a THIRD PARTY owns. Anything of ours belongs
 * in a theme variable.
 */

/* eslint-disable local-rules/no-hardcoded-color -- a third party's brand hue is fixed by that third party; see the file docblock */

/** LinkedIn's official brand blue (#0A66C2), for text and glyphs. */
export const LINKEDIN_BRAND_TEXT_CLASS = 'text-[#0A66C2]';

/** LinkedIn brand blue as a border, for an outline button on a LinkedIn action. */
export const LINKEDIN_BRAND_BORDER_CLASS = 'border-[#0A66C2]';

/** A 5% LinkedIn-blue wash, for the hover state of a LinkedIn outline button. */
export const LINKEDIN_BRAND_HOVER_BG_CLASS = 'hover:bg-[#0A66C2]/5';
